import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const BorderLinearProgress = styled(LinearProgress)({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#edf2f7", // Light gray background
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: "linear-gradient(90deg, #3182ce 0%, #805ad5 100%)", // Blue to Purple gradient
  },
});

const ProgressContainer = styled(Box)({
  padding: 24,
  background: "#ffffff",
  borderRadius: 8,
  width: "100%",
  //   boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  },
});

const ProgressMetrics = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "8px",
});

const MetricValue = styled(Typography)({
  fontSize: "0.875rem",
  color: "#718096", // Medium gray text
  fontWeight: 500,
});

interface ReferralProgressProps {
  currentReferrals?: number;
  maxReferrals?: number;
}

/**
 * ReferralProgress Component
 * Displays a stylized progress bar showing referral progress towards the minimum goal
 */
const ReferralProgress: React.FC<ReferralProgressProps> = ({
  currentReferrals = 0,
  maxReferrals = 15,
}) => {
  // Calculate progress percentage
  const progress = Math.min((currentReferrals / maxReferrals) * 100, 100);
  const remaining = Math.max(maxReferrals - currentReferrals, 0);

  return (
    <ProgressContainer>
      <BorderLinearProgress variant="determinate" value={progress} aria-label="referral progress" />

      <ProgressMetrics>
        <MetricValue>
          {currentReferrals} / {maxReferrals} Referrals
        </MetricValue>
        <MetricValue>{remaining > 0 ? `${remaining} more to go` : "Goal reached!"}</MetricValue>
      </ProgressMetrics>
    </ProgressContainer>
  );
};

export default ReferralProgress;
